import { axiosInstance } from '../../../../network/apis';
import { endpoints, ID } from '../../../../_metronic/constants/paths';

export const companyWithholdingTransactionsDetails = endpoints.companyTransactionsDetails;

export function getAllWithholdingTransactionsDetails({
  companyId,
  reportId,
  params,
}: {
  companyId: ID;
  reportId: ID;
  params?: any;
}) {
  return axiosInstance.get(companyWithholdingTransactionsDetails(companyId, reportId), { params });
}
